import { Reveal, Eyebrow } from "./Reveal";
import { education, certifications, achievements } from "../../data/resume";

export const Education = () => {
  return (
    <section
      id="education"
      data-testid="education-section"
      className="mx-auto max-w-[1400px] px-6 sm:px-12 lg:px-20 py-24 lg:py-36"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
        <div className="lg:col-span-4">
          <Reveal>
            <Eyebrow>(Education & Credentials)</Eyebrow>
            <h2 className="mt-6 font-serif font-normal text-4xl sm:text-5xl leading-[1.05] text-ink">
              Learning, always.
            </h2>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <div className="flex flex-col">
            {education.map((ed, i) => (
              <Reveal key={i} delay={0.05 * i}>
                <div
                  data-testid={`education-item-${i}`}
                  className="grid grid-cols-1 sm:grid-cols-12 gap-2 sm:gap-6 border-t border-hair py-7"
                >
                  <div className="sm:col-span-8">
                    <h3 className="font-serif text-xl sm:text-2xl text-ink">
                      {ed.program}
                    </h3>
                    <p className="mt-1 font-sans text-sm text-inksoft">
                      {ed.institution}
                    </p>
                  </div>
                  <div className="sm:col-span-4 sm:text-right">
                    <span className="font-mono text-xs uppercase tracking-[0.18em] text-inkmuted">
                      {ed.period}
                    </span>
                  </div>
                </div>
              </Reveal>
            ))}
            <div className="border-t border-hair" />
          </div>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-10">
            <Reveal>
              <h4 className="font-mono text-xs uppercase tracking-[0.22em] text-inkmuted">
                Certifications
              </h4>
              <ul className="mt-5 space-y-3">
                {certifications.map((c) => (
                  <li
                    key={c}
                    className="flex gap-3 font-sans text-sm sm:text-base text-inksoft"
                  >
                    <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-rust" />
                    {c}
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal delay={0.1}>
              <h4 className="font-mono text-xs uppercase tracking-[0.22em] text-inkmuted">
                Recognition
              </h4>
              <ul className="mt-5 space-y-3">
                {achievements.map((a) => (
                  <li
                    key={a}
                    className="flex gap-3 font-sans text-sm sm:text-base text-inksoft"
                  >
                    <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-rust" />
                    {a}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
